var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 1.83301C4.32367 1.83301 1.33301 4.82367 1.33301 8.49967C1.33301 12.1757 4.32367 15.1663 7.99967 15.1663C11.6757 15.1663 14.6663 12.1757 14.6663 8.49967C14.6663 4.82367 11.6757 1.83301 7.99967 1.83301ZM11.333 9.16634H8.66634V11.833H7.33301V9.16634H4.66634V7.83301H7.33301V5.16634H8.66634V7.83301H11.333V9.16634Z",
    fill: "#1F242E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add_icon.f98728415255092250bf339fca9c21e1.svg";
export { ForwardRef as ReactComponent };